module.exports = __webpack_public_path__ + "img/takeoff.6e8bdbbb.png";